import { HeaderRowCell } from './HeaderRowCell';
import { StyledHeaderGridRow } from './styles';

import { useColumns } from './hooks';
import { TABLE_GRID } from '../../constants';

export const HEADER_ROW_TEST_ID = 'list-table-header-row';

export const HeaderRow = () => {
  const columns = useColumns();

  return (
    <StyledHeaderGridRow gridLayout={TABLE_GRID} data-test={HEADER_ROW_TEST_ID}>
      {columns.map((column) => (
        <HeaderRowCell key={column.id} column={column} data-test={`header-row-cell-${column.id}`} />
      ))}
    </StyledHeaderGridRow>
  );
};
